/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchTrackableAssetsForFacilitiesBaleOutboundQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TrackableAssetsListFilter>;
}>;


export type SearchTrackableAssetsForFacilitiesBaleOutboundQuery = { __typename?: 'Query', trackableAssets?: Array<{ __typename?: 'TrackableAsset', id: string, assetType?: Types.AssetType | null, intendedMaterial?: Types.MaterialType | null, status?: Types.AssetStatus | null, shouldConfirmMaterial: boolean } | null> | null };

export type FacilityBaleOutboundMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.FacilityBaleOutboundInput>;
}>;


export type FacilityBaleOutboundMutation = { __typename?: 'Mutation', facilityBaleOutbound?: { __typename?: 'ScanEvent', id: string } | null };

export type UploadOutboundBalePhotoMutationVariables = Types.Exact<{
  input: Types.ScanEventPhotoInsertInput;
}>;


export type UploadOutboundBalePhotoMutation = { __typename?: 'Mutation', createScanEventPhoto?: { __typename?: 'ScanEventPhoto', id: string } | null };


export const SearchTrackableAssetsForFacilitiesBaleOutboundDocument = gql`
    query SearchTrackableAssetsForFacilitiesBaleOutbound($filter: TrackableAssetsListFilter) {
  trackableAssets(filter: $filter) {
    id
    assetType
    intendedMaterial
    status
    shouldConfirmMaterial
  }
}
    `;

/**
 * __useSearchTrackableAssetsForFacilitiesBaleOutboundQuery__
 *
 * To run a query within a React component, call `useSearchTrackableAssetsForFacilitiesBaleOutboundQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTrackableAssetsForFacilitiesBaleOutboundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTrackableAssetsForFacilitiesBaleOutboundQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchTrackableAssetsForFacilitiesBaleOutboundQuery(baseOptions?: Apollo.QueryHookOptions<SearchTrackableAssetsForFacilitiesBaleOutboundQuery, SearchTrackableAssetsForFacilitiesBaleOutboundQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTrackableAssetsForFacilitiesBaleOutboundQuery, SearchTrackableAssetsForFacilitiesBaleOutboundQueryVariables>(SearchTrackableAssetsForFacilitiesBaleOutboundDocument, options);
      }
export function useSearchTrackableAssetsForFacilitiesBaleOutboundLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTrackableAssetsForFacilitiesBaleOutboundQuery, SearchTrackableAssetsForFacilitiesBaleOutboundQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTrackableAssetsForFacilitiesBaleOutboundQuery, SearchTrackableAssetsForFacilitiesBaleOutboundQueryVariables>(SearchTrackableAssetsForFacilitiesBaleOutboundDocument, options);
        }
export function useSearchTrackableAssetsForFacilitiesBaleOutboundSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTrackableAssetsForFacilitiesBaleOutboundQuery, SearchTrackableAssetsForFacilitiesBaleOutboundQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTrackableAssetsForFacilitiesBaleOutboundQuery, SearchTrackableAssetsForFacilitiesBaleOutboundQueryVariables>(SearchTrackableAssetsForFacilitiesBaleOutboundDocument, options);
        }
export type SearchTrackableAssetsForFacilitiesBaleOutboundQueryHookResult = ReturnType<typeof useSearchTrackableAssetsForFacilitiesBaleOutboundQuery>;
export type SearchTrackableAssetsForFacilitiesBaleOutboundLazyQueryHookResult = ReturnType<typeof useSearchTrackableAssetsForFacilitiesBaleOutboundLazyQuery>;
export type SearchTrackableAssetsForFacilitiesBaleOutboundSuspenseQueryHookResult = ReturnType<typeof useSearchTrackableAssetsForFacilitiesBaleOutboundSuspenseQuery>;
export type SearchTrackableAssetsForFacilitiesBaleOutboundQueryResult = Apollo.QueryResult<SearchTrackableAssetsForFacilitiesBaleOutboundQuery, SearchTrackableAssetsForFacilitiesBaleOutboundQueryVariables>;
export const FacilityBaleOutboundDocument = gql`
    mutation FacilityBaleOutbound($input: FacilityBaleOutboundInput) {
  facilityBaleOutbound(input: $input) {
    id
  }
}
    `;
export type FacilityBaleOutboundMutationFn = Apollo.MutationFunction<FacilityBaleOutboundMutation, FacilityBaleOutboundMutationVariables>;

/**
 * __useFacilityBaleOutboundMutation__
 *
 * To run a mutation, you first call `useFacilityBaleOutboundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFacilityBaleOutboundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [facilityBaleOutboundMutation, { data, loading, error }] = useFacilityBaleOutboundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFacilityBaleOutboundMutation(baseOptions?: Apollo.MutationHookOptions<FacilityBaleOutboundMutation, FacilityBaleOutboundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FacilityBaleOutboundMutation, FacilityBaleOutboundMutationVariables>(FacilityBaleOutboundDocument, options);
      }
export type FacilityBaleOutboundMutationHookResult = ReturnType<typeof useFacilityBaleOutboundMutation>;
export type FacilityBaleOutboundMutationResult = Apollo.MutationResult<FacilityBaleOutboundMutation>;
export type FacilityBaleOutboundMutationOptions = Apollo.BaseMutationOptions<FacilityBaleOutboundMutation, FacilityBaleOutboundMutationVariables>;
export const UploadOutboundBalePhotoDocument = gql`
    mutation UploadOutboundBalePhoto($input: ScanEventPhotoInsertInput!) {
  createScanEventPhoto(input: $input) {
    id
  }
}
    `;
export type UploadOutboundBalePhotoMutationFn = Apollo.MutationFunction<UploadOutboundBalePhotoMutation, UploadOutboundBalePhotoMutationVariables>;

/**
 * __useUploadOutboundBalePhotoMutation__
 *
 * To run a mutation, you first call `useUploadOutboundBalePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadOutboundBalePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadOutboundBalePhotoMutation, { data, loading, error }] = useUploadOutboundBalePhotoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadOutboundBalePhotoMutation(baseOptions?: Apollo.MutationHookOptions<UploadOutboundBalePhotoMutation, UploadOutboundBalePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadOutboundBalePhotoMutation, UploadOutboundBalePhotoMutationVariables>(UploadOutboundBalePhotoDocument, options);
      }
export type UploadOutboundBalePhotoMutationHookResult = ReturnType<typeof useUploadOutboundBalePhotoMutation>;
export type UploadOutboundBalePhotoMutationResult = Apollo.MutationResult<UploadOutboundBalePhotoMutation>;
export type UploadOutboundBalePhotoMutationOptions = Apollo.BaseMutationOptions<UploadOutboundBalePhotoMutation, UploadOutboundBalePhotoMutationVariables>;